// cidadeService.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { Cidade } from "../interfaces/Cidade";

export const cidadeService = async (estadoId?: number | undefined) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cidade`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        let cidadesSystem;
        // Verifica se é enviado o id do estado para filtro
        if (estadoId !== null && estadoId !== undefined) {
          cidadesSystem = response.data.filter(
            (cidade: Cidade) =>
              cidade.origem === 0 && cidade.estadoId === estadoId
          );
        }
        // Se nada foi enviado, entao ele me traz todos as cidades do sistema
        else {
          cidadesSystem = response.data.filter(
            (cidade: Cidade) => cidade.origem === 0
          );
        }

        return cidadesSystem;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
